import { useEffect } from "react";


export const SpeakersForm = () => {
   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               region: "na1",
               portalId: '536350',
               formId: '5b40cece-7414-4263-8cee-9bc41eb4c83e',
               target: '#speakersForm',
            })
         }
      });
   }, []);

   return (
      <div className="footer-form speakers-form">
         <h1>Apply to Speak</h1>
         <p>Fill out the form below if you’re interested in speaking or hosting a workshop</p>
         <div id="speakersForm" />
      </div>
   )
}
